import { render, staticRenderFns } from "./sm-input-verification-code.vue?vue&type=template&id=0d0c665d&scoped=true&"
import script from "./sm-input-verification-code.vue?vue&type=script&lang=js&"
export * from "./sm-input-verification-code.vue?vue&type=script&lang=js&"
import style0 from "./sm-input-verification-code.vue?vue&type=style&index=0&id=0d0c665d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c665d",
  null
  
)

export default component.exports